import api from '../utils/api';

// VALSOFT proof-of-delivery attestation — one immutable record per clinic.

export interface DeliveryAttestationRecord {
  id: string;
  clinicId: string;
  recordId: string; // human-readable audit id, e.g. ATT-483920
  submittedByUserId: string;
  submittedByName: string;
  submittedByRole: string;
  accessReceivedAt: string;
  createdAt: string;
}

export interface DeliveryAttestationStatus {
  required: boolean;
  attestation: DeliveryAttestationRecord | null;
}

export interface SubmitDeliveryAttestationRequest {
  accessReceivedDate: string; // ISO date (yyyy-mm-dd)
  ableToLogIn: boolean; // must be true — the backend rejects 'no' by contract
  fullName: string;
  role: string; // free-text role at the practice
  attested: boolean; // the attestation checkbox — must be true
}

export const deliveryAttestationService = {
  async getStatus(): Promise<DeliveryAttestationStatus> {
    const response = await api.get<DeliveryAttestationStatus>('/delivery-attestation');
    return response.data;
  },

  async submit(data: SubmitDeliveryAttestationRequest): Promise<DeliveryAttestationRecord> {
    const response = await api.post<DeliveryAttestationRecord>('/delivery-attestation', data);
    return response.data;
  },
};
